.editable-grid-container {
  display: block;

  width: 100%;
  height: 100%;

  border-radius: 10px;
  border: 1px solid hsl(0, 0%, 40%);
  perspective: 1px;

  overflow: hidden;
}

.tabla-def-grid {
  display: grid;

  width: 100%;
  height: 100%;

  grid-template-rows: minmax(3rem, max-content);
  grid-auto-rows: max-content;

  overflow: scroll;
  scroll-snap-type: x mandatory;
}

.tabla-def-grid > div {
  scroll-snap-align: start;
  scroll-snap-stop: always;
  scroll-padding: 8%;
}

.empty-cell,
.column-title-cell,
.row-title-cell {
  background-color: #2a898e;
  align-content: center;
  text-align: center;
  font-weight: 600;
  color: white;
}

.empty-cell,
.column-title-cell,
.row-title-cell,
.grid-cell {
  padding: 0.3rem;
}

.grid-cell {
  background-color: white;
  border: 1px solid #ddd;
  padding: 0.5rem;
}

/* Skeleton */
.tabla-def-grid.skeletonActive {
  gap: 0.5rem;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(5, 8rem);
}

.skeleton-cell {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}

.skeleton-cell::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(180, 180, 180, 0.5) 20%,
    rgba(96, 96, 96, 0.3) 60%,
    transparent 100%
  );
  transform: translateX(-100%);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

.error-table-data {
  display: flex;

  width: 100%;
  height: 100%;

  place-content: center;
  place-items: center;
}

.error-table-data > .message {
  --color: #ce2029;
  --bg-color: #e88b8b;

  text-align: center;

  border-radius: 10px;
  border: 1px solid hsla(from var(--bg-color) h s 60% / 1);
  box-shadow: hsla(from var(--bg-color) h s 60% / 0.6) 0 0 4rem -0.5rem;
  background-color: var(--bg-color);

  padding: 1rem;
  display: grid;
  justify-items: center;
}

.error-table-data > .message svg {
  width: 6rem;
  height: auto;
  stroke: var(--color);
}
.error-table-data > .message p {
  font-size: 2rem;
  font-weight: 600;
  color: var(--color);
}
